import { Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslationService } from '../../services/translation.service';

@Pipe({
    name: 'translatePlaceholder',
    standalone: false
})

//Added because of https://calliduscloud.atlassian.net/browse/CPQ-11585
export class TranslatePlaceholderPipe implements PipeTransform {
    constructor(private route: ActivatedRoute, private translationService: TranslationService) { }

    /**
     * @param key  The key
     * @return translated value or key if does not exists
     */

    public transform(key: string): string {
        const isIE = /msie\s|trident\//i.test(window.navigator.userAgent); // check if IE, apply only if IE
        if(isIE && !(/^[A-Za-z0-9\s!@#$%^&*()_+=-`~\\\]\[{}|';:/.,?><]*$/.test(this.translationService.translate(key)))) { // allowed  characters, all latin (without diacritics), numbers, special
            return "";
        }
        else {
            return this.translationService.translate(key);
        }
    }

}
